@if (showInviteMore()) {
<app-dashed-content data-test-id="users-invite-dialog-dashed-content">
  <app-text
    [size]="TextSize.BODY_2"
    [height]="TextHeight.MEDIUM"
    [color]="TextColor.NEUTRAL_6"
    [weight]="TextWeight.REGULAR"
    [align]="TextAlign.CENTER"
    [spacingBottom]="Spacing.MEDIUM"
    >{{ 'users.inviteInstructions' | translate }}</app-text
  >
  @if (!isEmailRegexWildcard) {
  <app-text
    [size]="TextSize.BODY_2"
    [height]="TextHeight.MEDIUM"
    [color]="TextColor.NEUTRAL_6"
    [weight]="TextWeight.REGULAR"
    [align]="TextAlign.CENTER"
    [spacingBottom]="Spacing.X_LARGE"
    >{{ acceptedDomains }}</app-text
  >
  }
  <app-text-input
    [type]="InputType.TEXT"
    [size]="InputSize.LARGE"
    [(value)]="emailCSVList"
    [error]="emailCSVListError()"
    [direction]="InputDirection.VERTICAL"
    [width]="InputWidth.FULL"
    placeholder="Email Address"
    data-test-id="users-invite-dialog-email-input"
  ></app-text-input>
</app-dashed-content>
<app-view
  [direction]="ViewDirection.ROW"
  [align]="ViewAlign.CENTER"
  [justify]="ViewJustify.CENTER"
>
  <app-button
    [type]="ButtonType.PRIMARY"
    [disabled]="submitDisabled()"
    (handleClick)="handleInviteSubmit()"
    [spacingBottom]="Spacing.NONE"
    [size]="ButtonSize.SMALL"
    data-test-id="users-invite-dialog-submit-button"
    >{{ 'users.submit-invite' | translate }}</app-button
  >
</app-view>
} @else {
<app-view
  [direction]="ViewDirection.COLUMN"
  [spacingBottom]="Spacing.X_LARGE"
  [gap]="Spacing.SMALL"
>
  @if (successfullInvites() > 0) {
  <app-text
    [size]="TextSize.TITLE_2"
    [height]="TextHeight.TITLE_1"
    [color]="TextColor.NEUTRAL_8"
    [weight]="TextWeight.BOLD"
    >{{ successTitle() }}</app-text
  >
  } @if (failedInvites() > 0) {
  <app-text
    [size]="TextSize.TITLE_2"
    [height]="TextHeight.TITLE_1"
    [color]="TextColor.NEUTRAL_8"
    [weight]="TextWeight.BOLD"
    >{{ failTitle() }}</app-text
  >
  }
</app-view>
<app-view [direction]="ViewDirection.COLUMN" [spacingBottom]="Spacing.X_LARGE">
  <div class="dialog-list-wrapper">
    <ul class="dialog-list" data-test-id="users-invite-dialog-list">
      <li
        *ngFor="let result of inviteUserResults()"
        data-test-id="users-invite-dialog-list-item"
      >
        @if (result.status === InviteUserResultStatus.SUCCESS) {
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-test-id="users-invite-dialog-icon-success"
        >
          <g clip-path="url(#clip0_2806_499)">
            <path
              d="M9.00014 16.17L5.53014 12.7C5.14014 12.31 4.51014 12.31 4.12014 12.7C3.73014 13.09 3.73014 13.72 4.12014 14.11L8.30014 18.29C8.69014 18.68 9.32014 18.68 9.71014 18.29L20.2901 7.71C20.6801 7.32 20.6801 6.69 20.2901 6.3C19.9001 5.91 19.2701 5.91 18.8801 6.3L9.00014 16.17Z"
              fill="#14E25A"
            />
          </g>
          <defs>
            <clipPath id="clip0_2806_499">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        } @else {
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-test-id="users-invite-dialog-icon-fail"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
            fill="#F5BCC5"
          />
        </svg>
        }
        <app-text
          [size]="TextSize.BODY_1"
          [height]="TextHeight.SMALL"
          [weight]="TextWeight.BOLD"
          >{{ result.email }}</app-text
        >
        <div>
          <app-text
            [size]="TextSize.BODY_1"
            [height]="TextHeight.SMALL"
            [weight]="TextWeight.REGULAR"
            >{{ 'users.invite-status-' + result.status | translate }}</app-text
          >
        </div>
      </li>
    </ul>
  </div>
</app-view>
<app-view
  [direction]="ViewDirection.ROW"
  [align]="ViewAlign.CENTER"
  [justify]="ViewJustify.END"
  [gap]="Spacing.MEDIUM"
>
  <app-button
    [type]="ButtonType.SECONDARY"
    (handleClick)="handleInviteMore()"
    [size]="ButtonSize.SMALL"
    data-test-id="users-invite-dialog-invite-more-button"
    [spacingBottom]="Spacing.NONE"
    >{{ 'users.invite-more' | translate }}</app-button
  >
  <app-button
    [type]="ButtonType.PRIMARY"
    (handleClick)="handleDone()"
    [size]="ButtonSize.SMALL"
    data-test-id="users-invite-dialog-done-button"
    [spacingBottom]="Spacing.NONE"
    >{{ 'users.done' | translate }}</app-button
  >
</app-view>
}
